import { TimelineMax } from 'gsap';
import CustomEase from './CustomEase';

// console.log(CustomEase);
// const CustomEase = require('./greensock-js-with-customease/src/uncompressed/easing/CustomEase');
const lottie = require('lottie-web');
const animWrapper = document.getElementById('svg-animation');
const animData = require('./wave03_test.json');


const anim = lottie.loadAnimation({
    wrapper: animWrapper,
    animType: 'svg',
    loop: false,
    prerender: true,
    autoplay: false,
    animationData: animData,
    // path: '/js/wave02_test.json',
    rendererSettings: {
        // preserveAspectRatio: "xMidYMid slice"
        // context: canvasContext, // the canvas context
        // scaleMode: 'noScale',
        // clearCanvas: false,
        // progressiveLoad: false, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
        // hideOnTransparent: true //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
    }
});

const gradients = [
  ['064386', '5f2d5e', 'BB1337'],
  ['038594', '3d8db3', '6F94D7'],
  ['0A8BB7', '1881c0', '0574CD'],
  ['3A0B0B', '45211a', '523726'],
  ['810B20', 'be6c39', 'FFCE45'],
  ['E92AE7', '7b30ac', '0E2874'],
  ['F00102', '800e23', '131641'],
  ['090A11', '44487a', '7F84E7'],
  ['1F262E', 'FD379C', '1F262E'],
  ['D52D18', '96331b', '5B370E'],
  ['F2E295', 'b5725a', '790218'],
  ['5D81F7', '335bd4', '032CB6']
];
let gradientStops;

let tl;
let numTotal = 12;
let loaded = false;
let requestedIndex = -1;

const playFromTo = (from, to, fromColors, toColors, time = 1) => {
    if (tl) tl.kill();

    let ease = CustomEase.create("custom", "M0,0 C0.158,0 0.264,0.416 0.342,0.658 0.41,0.87 0.59,1 1,1");

    if (time > 1.5) {
        ease = CustomEase.create("custom", "M0,0 C0.046,0 0.137,0.016 0.232,0.16 0.37,0.37 0.576,0.698 0.658,0.82 0.737,0.938 0.818,1 1,1");
    }

    tl = new TimelineMax();
    tl.to(
        {
            frame: from
        }, time,
        {
            frame: to,
            onUpdate: function () {
                anim.goToAndStop(Math.round(this.target.frame / anim.frameModifier));
            },
            ease: ease
            // ease: Sine.easeInOut
        },
        'st'
    );
    if (!fromColors)
        updateGradient(toColors);
    else
        tl.to(
            {
                ratio: 0
            }, time,
            {
                ratio: 1,
                onUpdate: function () {
                    let arr = [];
                    let i;
                    let l = Math.min(fromColors.length, toColors.length);
                    for (i = 0; i < l; i++)
                    {
                        arr.push(colorTransition(fromColors[i], toColors[i], this.target.ratio));
                    }
                    updateGradient(arr);
                }
            },
            'st'
        );
};

const scale = (number, oldMin, oldMax, newMin, newMax) => {
    if (number < oldMin) {
        throw new Error('number is less than oldMin');
    }
    if (number > oldMax) {
        throw new Error('number is greater than oldMax');
    }
    return (newMax - newMin) * (number - oldMin) / (oldMax - oldMin) + newMin;
};

const colorTransition = (color1, color2, ratio) => {
    let hex = function(x) {
        x = x.toString(16);
        return (x.length === 1) ? '0' + x : x;
    };

    let r = Math.ceil(parseInt(color2.substring(0,2), 16) * ratio + parseInt(color1.substring(0,2), 16) * (1-ratio));
    let g = Math.ceil(parseInt(color2.substring(2,4), 16) * ratio + parseInt(color1.substring(2,4), 16) * (1-ratio));
    let b = Math.ceil(parseInt(color2.substring(4,6), 16) * ratio + parseInt(color1.substring(4,6), 16) * (1-ratio));

    return hex(r) + hex(g) + hex(b);
}

anim.addEventListener('DOMLoaded', function() {
    loaded = true;

    initGradient(animWrapper);

    if (requestedIndex > -1)
        goto(requestedIndex);
});

function goto(index, atOnce) {
    if (index < 1 || index > numTotal) return;
    if (!loaded) {
        requestedIndex = index;
        return;
    }
    let offset = 25;
    let min = 0;
    let max = anim.totalFrames - 1 - offset;
    let to = Math.round((max - min) / (numTotal - 1) * (index-1) + min);
    let from = Math.round(anim.currentFrame);

    if (atOnce)
    {
        playFromTo(from, to, null, gradients[index - 1], 0);
        return;
    }

    let diff = Math.abs(to - from);
    diff = scale(diff, min, max, 0, 1);

    let time = parseFloat(scale(diff, 0, 1, 0.6, 3).toFixed(1));

    playFromTo(from, to, getCurrentGradient() || ["000000","000000","000000"], gradients[index - 1] || ["000000","000000","000000"], time);
}

function calculateDuration(delta) {
    let offset = 25;
    let min = 0;
    let max = anim.totalFrames - 1 - offset;
    let to = Math.round((max - min) / (numTotal - 1) * (delta-1) + min);
    let from = Math.round(0);

    let diff = Math.abs(to - from);
    diff = scale(diff, min, max, 0, 1);

    return parseFloat(scale(diff, 0, 1, 0.6, 3).toFixed(1));
}

function initGradient(root) {
    let el = root.querySelector('linearGradient');
    gradientStops = [...el.querySelectorAll('stop')];
}

function getCurrentGradient() {
    let i;
    let el;
    let arr = [];
    for (i = 0; i < gradientStops.length; i++)
    {
        el = gradientStops[i];
        arr.push(el.getAttribute('stop-color').substr(1));
    }
    return arr.length ? arr : null;
}

function updateGradient(colors) {
    let i;
    let l = Math.min(colors.length, gradientStops.length);
    let el;
    for (i = 0; i < l; i++)
    {
        el = gradientStops[i];
        el.setAttribute('stop-color', '#' + colors[i]);
    }
}

module.exports.goto = goto;
module.exports.calculateDuration = calculateDuration;



// WEBPACK FOOTER //
// ./js/bg-animation.js